module.exports = __webpack_public_path__ + "static/img/novice3.e25713e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/novice3.jpg
// module id = Vyx+
// module chunks = 1